import * as FileVersionConstants from './FileVersionConstants';

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require('object.assign');

const initialState = {
    isVersionFetching : false,
    isVersionFetched : false,
    isVersionFailed : false,
    version :''
}

export default function VersionNumberReducer(state = initialState, action){

    switch(action.type) {

        case FileVersionConstants.FETCH_VERSION_REQUEST:
            return assign({}, state, {
                isVersionFetching : true,
                isVersionFetched : false,
                isVersionFailed : false
            });
            break;

        case FileVersionConstants.FETCH_VERSION_REQUEST_SUCCESS:
            let updatedVersion = action.newState.result.PRODUCT_VERSION;                                             
            return assign({}, state, {
                isVersionFetching : false,
                isVersionFetched : true,
                isVersionFailed : false,
                version : updatedVersion
            });
            break;

        case FileVersionConstants.FETCH_VERSION_REQUEST_FAILURE:
            return assign({}, state, {
                isVersionFetching : false,
                isVersionFetched : false,
                isVersionFailed : true
            });
            break;
        
        default :
            return state;

    }

}